import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

import { useSmoothScroll } from '@hpstellar/core/hooks';
import ChevronUp from '@hpstellar/core/Icons/ChevronUp';

import './scroll-up-button.less';

export default function ScrollUpButton() {
    const { scrollToY } = useSmoothScroll();

    const [scroll, setScroll] = useState(0);

    const onScroll = throttle(() => {
        setScroll(window.pageYOffset);
    }, 300);

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <button
            onClick={() => scrollToY(0)}
            className={`scrollUpButton ${scroll > 2500 ? ' show' : ''}${scroll > 1023 ? ' showMobile' : ''}`}
            type="button"
            aria-label="scroll to top"
        >
            <ChevronUp size="s" />
        </button>
    );
}
